import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Agitation from "@/components/site/Agitation";
import Mirror from "@/components/site/Mirror";
import PrologueReader from "@/components/site/PrologueReader";
import QuoteBlock from "@/components/site/QuoteBlock";
import Praise from "@/components/site/Praise";
import Share from "@/components/site/Share";
import Checkout from "@/components/site/Checkout";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Agitation />
        <Mirror />
        <Praise />
        <PrologueReader />
        <QuoteBlock />
        <Share />
        <Checkout />
      </main>
      <Footer />
    </>
  );
}
